import type { SVGProps } from 'react';
const SvgPresentToAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#present_to_all_svg__a)">
      <path
        fill="currentColor"
        d="M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2Zm0 16.02H3V4.98h18v14.04ZM10 12H8l4-4 4 4h-2v4h-4v-4Z"
      />
    </g>
    <defs>
      <clipPath id="present_to_all_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPresentToAll;
